import { Button } from '@grupoboticario/flora-react';
import { ReactNode } from 'react';
import { MdOutlineFileDownload } from 'react-icons/md';
import { downloadFile } from 'utils/downloadFile';
import { DownloadWrapper } from './styles';

interface DownloadProps {
  readonly header: ReactNode;
  readonly uri: string;
  readonly filename?: string;
  readonly loading?: boolean;
}

export function Download({
  uri,
  filename = '',
  header,
  loading,
}: Readonly<DownloadProps>) {
  return (
    <DownloadWrapper>
      {header}
      <MdOutlineFileDownload className="download" />
      <Button
        className="downloadButton"
        size="small"
        onClick={() => downloadFile(uri, filename)}
        disabled={!uri}
        isLoading={loading}
      >
        Baixar
      </Button>
    </DownloadWrapper>
  );
}
